const styles = {
    root: {
        width: '100%',
        height: '100%',
        position: 'relative'
    }
};

export default styles;
